import {FormLabel} from "@mui/material";
import styled from "styled-components";

export const FormLabelStyled = styled(FormLabel)`
	font-family: "Poppins";
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 160%;
	color: #a5acbb;
`;
